var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"spinner-icon"},[(_vm.message)?_c('h3',[_vm._v(_vm._s(_vm.message))]):_vm._e(),_vm._v(" "),_c('pulse-loader',{attrs:{"loading":true}})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }